// import { Injectable } from "@angular/core";
// import {
//   ActivatedRouteSnapshot,
//   CanActivate,
//   RouterStateSnapshot,
//   UrlTree,
// } from "@angular/router";
// import { Observable } from "rxjs";

import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { catchError, Observable, of, switchMap } from "rxjs";
import { AuthService } from "./auth.service";
import { CommonService } from "src/app/services/common/common.service";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router, private commonService : CommonService, private AuthenticationService: AuthenticationService) {}

  //old
  // canActivate() {
  //   if (this.auth.isLoggedIn()) {
  //     return true;
  //   }
  //   this.route.navigate(["login"]);
  //   return false;
  // }

  //new
  canActivate(): Observable<boolean> {
    if (this.auth.isLoggedIn()) {
      return of(true); // Allow access if logged in
    } else {
      let  customerActionLogsId = localStorage.getItem("customerActionLogsId");
      // Call the logout logging service
      return this.commonService
        .logout(customerActionLogsId)
        .pipe(
          switchMap(() => {
            this.AuthenticationService.logoutUser();
            // Clear local storage and navigate to login
            localStorage.clear();
            this.router.navigate(["login"]);
            return of(false); // Deny access
          }),
          catchError((error) => {
            // Handle errors here (optional)
            console.error("Error logging logout action:", error);
            localStorage.clear();
            this.router.navigate(["login"]);
            return of(false); // Deny access
          })
        );
    }
  }


  //oldest code - not used
  // canActivate(
  //   route: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  //   return true;
  // }
}
